import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import AbroadPerfectPackageData from '../../../Models/Content/AbroadPerfectPackageBlockData';
import AbroadPerfectPackage from './AbroadPerfectPackage'

export default class AbroadPerfectPackageBlock extends EpiComponent<AbroadPerfectPackageData> {
 
  
    constructor(props) {
      super(props);
    }
  
    public render(): ReactNode | ReactNodeArray | null {
      return <AbroadPerfectPackage context={this.getContext()} data={this.props.data} />          
    }
 
}
